module.exports = __webpack_public_path__ + "static/img/dumplings.48d0ca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dumplings.png
// module id = jM2C
// module chunks = 1